import { api } from 'src/api';
import { PrescriberTermsOfUse } from './prescriber';

export const AssistantService = {
  async createUser(payload: CreateAssistantPayload): Promise<void> {
    await api.put(`/prescriber-assistant/registration`, payload);
  },
  async getAssistants(): Promise<GetAssistantResponse> {
    const { data } = await api.get(`/prescriber-assistant/list-assistants`);

    return data;
  },

  async getDoctors(): Promise<GetDoctorsResponse> {
    const { data } = await api.get(`/prescriber-assistant/list-prescribers`);

    return data;
  },

  async inviteAssistant(payload: InviteAssistantPayload): Promise<void> {
    await api.post(`/prescriber-assistant/invite`, payload);
  },

  async removeAssistant(assistantId: string): Promise<void> {
    await api.delete(`/prescriber-assistant/remove/${assistantId}`);
  },

  async getAssistant(assistantId: string): Promise<AssistantData> {
    const { data } = await api.get(`/prescriber-assistant/${assistantId}`);

    return data;
  },

  async updateAssistant(assistantId: string, payload: AssistantData): Promise<AssistantData> {
    const { data } = await api.put(`/prescriber-assistant/${assistantId}`, payload);

    return data;
  },

  async validatePerson(payload: ValidatePersonPayload): Promise<boolean> {
    const { data } = await api.post('/prescriber-assistant/validatePerson', payload);
    return data.isValid;
  },

  async validateCfm(payload: ValidateCfmPayload): Promise<boolean> {
    const { data } = await api.post('/prescriber-assistant/validateCfm', payload);
    return data.isValid;
  },
};

export interface CreateAssistantPayload {
  email: string;
  fullName: string;
  birthdate: string;
  cpf: string;
  cellphoneNumber: string;
  password: string;
  createdThroughApp: boolean;
  acceptedNewsLetter: boolean;
  consentTerm: PrescriberTermsOfUse;
}

export interface GetAssistantResponse {
  prescriberAssistants: Assistant[];
  total: number;
}

export interface AssistantData {
  _id: string;
  fullName: string;
  cpf: string;
  cellphoneNumber: string;
  email: string;
  birthdate: string;
}

export interface DoctorAssistantData {
  prescriber: {
    email: string;
    fullName: string;
    _id: string;
  };
}

export interface GetDoctorsResponse {
  prescribers: DoctorAssistantData[];
  total: number;
}

export enum ASSISTANT_STATUS_ENUM {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ACTIVATION_PENDING = 'ACTIVATION_PENDING',
  BLOCKED = 'BLOCKED',
  COMPLETE_REGISTRATION_PENDING = 'COMPLETE_REGISTRATION_PENDING',
}

export interface Assistant {
  assistant: {
    _id: string;
    email: string;
    accountStatus: ASSISTANT_STATUS_ENUM;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  linkStatus: string;
}

export interface InviteAssistantPayload {
  email: string;
  prescriberId: string;
  inviteUrl: string;
}

export interface ValidatePersonPayload {
  cpf: string;
  birthDate: string;
}

export interface ValidateCfmPayload {
  crm: string;
  state: string;
  cpf: string;
  birthDate: string;
}
